import axios from 'axios'

export default function(file) {
  return axios.get(file, {
    headers: {
      'Cache-Control': 'public, max-age=60480',
    },
  })
}



// WEBPACK FOOTER //
// ./src/lib/getScript.js